import React from "react";
import {
  RoleNameBlock2,
  SongBlock2,
  LogoBlock,
  BlurbBlock,
  NameOnlyBlock2,
} from "./BlockType/index";
import "./Block.css";

const getBlock = (options, items, idx, settings) => {
  var returnBlock = <></>;
  switch (options.block_type) {
    case "rolename":
      returnBlock = (
        <>
          <RoleNameBlock2
            options={options}
            items={items}
            idx={idx}
            settings={settings}
          />
        </>
      );
      break;

    case "nameonly":
      returnBlock = (
        <>
          <NameOnlyBlock2
            options={options}
            items={items}
            idx={idx}
            settings={settings}
          />
        </>
      );
      break;

    case "song":
      returnBlock = (
        <>
          <SongBlock2
            options={options}
            items={items}
            idx={idx}
            settings={settings}
          />
        </>
      );
      break;

    case "logo":
      returnBlock = (
        <LogoBlock
          options={options}
          items={items}
          idx={idx}
          settings={settings}
        />
      );
      break;

    case "blurb":
      returnBlock = (
        <BlurbBlock
          options={options}
          items={items}
          idx={idx}
          settings={settings}
        />
      );
      break;

    default:
      returnBlock = options.block_type;
  }

  return returnBlock;
};

export default function Block({ options, items, idx, settings }) {
  return (
    options?.text_alignment && (
      <div
        className={"block_ w-full "}
        style={{ margin: "0 auto", padding: "10px 0px" , backgroundColor:'', display:'flex', justifyContent:'center', alignItems:'baseline'}}
      >
        {getBlock(options, items, idx, settings)}{" "}
      </div>
    )
  );
}